window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.getGlowRvpThreshold = function () {
    const thresholdStr = this.getConfigSetting('glowThreshold', '200%');
    const match = String(thresholdStr).match(/(\d+)\s*%/);
    const pct = match ? parseInt(match[1], 10) : 50;
    return 100 + pct;
};

window.StockCubeCore.applyEmissiveHighlight = function (barEl, stock, baseColor) {
    const interval = (this.data && this.data.interval ? this.data.interval : '1d').toLowerCase();
    const daypartRelativeVolumePercentage = Number((stock && stock.daypart_relative_volume_percentage) || 0);
    const isGlowOn = !!this.getConfigSetting('isGlowOn', false);
    const isAnimationOn = !!this.getConfigSetting('isAnimationOn', true);
    const isAnimating = !!(this.data?.timelineEntity?.components?.['timeline-control']?.isAnimating);
    const isFirstPlay = !!this.isFirstAnimationPlay;
    const dataSource = this.data && this.data.dataSource;
    const excludedBloomSources = ['dividend', 'dividend-sec', 'sip', 'sip-sec', 'mmap'];
    
    if (excludedBloomSources.includes(dataSource)) {
        this.clearEmissiveFromBar(barEl);
        return;
    }

    if (isAnimationOn && isAnimating && isFirstPlay) {
        this.clearEmissiveFromBar(barEl);
        return;
    }

    const rvpThreshold = this.getGlowRvpThreshold();
    const shouldGlow = interval === '1d' && daypartRelativeVolumePercentage >= rvpThreshold && isGlowOn;

    if (shouldGlow) {
        const emissiveColor = baseColor || barEl.getAttribute('color') || '#ffffff';
        const luminance = this.calculateLuminance(emissiveColor);
        const safeLuminance = Math.max(0.05, luminance);
        // const minIntensity = Math.max(0.2, 0.5 / safeLuminance);
        const minIntensity = 0.1; 
        const maxIntensity = Math.max(2.0, 2.0 / safeLuminance); 

        barEl.setAttribute('material', 'emissive', emissiveColor);
        barEl.setAttribute('material', 'emissiveIntensity', minIntensity);
        barEl.removeAttribute('animation__emissive');

        if (this.emissivePulse && this.emissivePulse.bars) {
            let labelEl = null;
            if (this.stockBars) {
                const ticker = (stock && stock.ticker) || (barEl.__stockData && barEl.__stockData.ticker);
                if (ticker) {
                    const barInfo = this.stockBars.get(ticker);
                    labelEl = (barInfo && barInfo.primaryLabel) || null;
                }
            }
            this.emissivePulse.bars.set(barEl.object3D.uuid, {
                el: barEl,
                min: minIntensity,
                max: maxIntensity,
                color: emissiveColor,
                labelEl,
            });
        }
    } else {
        this.clearEmissiveFromBar(barEl);
    }
};

window.StockCubeCore.refreshEmissiveForAllBars = function () {
    if (!this.stockBars || this.stockBars.size === 0) return;
    for (const [, barInfo] of this.stockBars) {
        const barEl = barInfo.bar;
        if (!barEl) continue;
        let stock = barEl.__stockData || null;
        if (!stock) {
            const stockDataAttr = barEl.getAttribute('stock-bar');
            if (stockDataAttr && stockDataAttr.stockData) {
                try {
                    stock = JSON.parse(stockDataAttr.stockData);
                    barEl.__stockData = stock;
                } catch (e) {
                    stock = null;
                }
            }
        }
        const baseColor = barEl.getAttribute('color') || '#ffffff';
        this.applyEmissiveHighlight(barEl, stock, baseColor);
    }
};

window.StockCubeCore.clearEmissiveFromBar = function (barEl) {
    if (this.emissivePulse && this.emissivePulse.bars) {
        const entry = this.emissivePulse.bars.get(barEl.object3D.uuid);
        if (entry && entry.labelEl) {
            entry.labelEl.setAttribute('scale', '1 1 1');
        }
        this.emissivePulse.bars.delete(barEl.object3D.uuid);
    }
    barEl.removeAttribute('animation__emissive');
    barEl.setAttribute('material', 'emissive', '#000000');
    barEl.setAttribute('material', 'emissiveIntensity', 0);
};
